import maxAttemptExceeded from "../../../../../../public/images/access-screens/maxAttemptExceeded.png";
import { useTranslation } from "react-i18next";

const MaxAttemptExceeded = ({
  orgBasedFeatureName = "assessment"
}: {
  orgBasedFeatureName: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center space-y-5 text-center w-full py-10">
      <img
        src={maxAttemptExceeded}
        alt={t("assessment.accessScreens.maxAttemptExceeded.alt")}
        className="w-[300px] h-[300px] lg:w-[500px] lg:h-[500px] object-cover"
      />
      <div className="max-w-[800px]">
        <h1 className="text-2xl text-primary font-bold">
          {t("assessment.accessScreens.maxAttemptExceeded.title")}
        </h1>
        <p className="mt-5 text-primary text-base">
          {t("assessment.accessScreens.maxAttemptExceeded.description", {
            featureName: orgBasedFeatureName
          })}
        </p>
      </div>
    </div>
  );
};

export default MaxAttemptExceeded;
